import { render, staticRenderFns } from "./EditNotebookDialog.vue?vue&type=template&id=9650c03c&scoped=true&"
import script from "./EditNotebookDialog.vue?vue&type=script&lang=js&"
export * from "./EditNotebookDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditNotebookDialog.vue?vue&type=style&index=0&id=9650c03c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9650c03c",
  null
  
)

component.options.__file = "EditNotebookDialog.vue"
export default component.exports